import React, { useState } from 'react';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import SegpoolAudit from './SegpoolAudit';
import NicehashAudit from './NicehashAudit';
import FinanceReportAudit from './FinanceReportAudit';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`audit-tabpanel-${index}`}
            aria-labelledby={`audit-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography component="div">{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `audit-tab-${index}`,
        'aria-controls': `audit-tabpanel-${index}`,
    };
}

const AuditControl = () => {
    const [value, setValue] = useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="audit tabs">
                    <Tab label="Segpool Machine Audit" {...a11yProps(0)} />
                    <Tab label="Nicehash Machine Audit" {...a11yProps(1)} />
                    <Tab label="Finance Report Audit" {...a11yProps(2)} />
                </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
                <SegpoolAudit />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
                <NicehashAudit />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
                <FinanceReportAudit />
            </CustomTabPanel>
        </Box>
    );
};

export default AuditControl;
